import { AppUser, User } from '~/store/user/models';

export const fakeUserData: AppUser = {
    userId: 0,
    companyName: '',
    creatorCompanyName: '',
    token: '',
    name: '',
    kontactId: 0,
    kontactCode: '',
    creatorCode: '',
    fullName: '',
    address: '',
    route: '',
    countryName: '',
    cityName: '',
    zipCode: '',
    phone: '',
    phone2: '',
    phone3: '',
    phone4: '',
    phoneType: 1,
    phoneType2: 1,
    phoneType3: 1,
    phoneType4: 1,
    konAddId: 0,
    creatorKonAddId: 0,
    email: '',
    image: '/fake-user-image.png',
    role: '',
    description: '',
    country: '',
    position: '',
    contacts: [],
    dealContacts: [],
    contactTypeDesc: '',
    contactStatus: '',
    contactCode: '',
    firstName: '',
    lastName: '',
    startDate: '',
    endDate: '',
    contactId: 0,
    ipiList: [],
    street: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    addressLine4: '',
    projectContactId: 0,
    AKAsList: [],
};

export const fakeContactData: User = {
    userId: 0,
    name: '',
    creatorCompanyName: '',
    companyName: '',
    fullName: '',
    address: '',
    route: '',
    countryName: '',
    cityName: '',
    zipCode: '',
    phone: '',
    phone2: '',
    phone3: '',
    phone4: '',
    phoneType: 0,
    phoneType2: 0,
    phoneType3: 0,
    phoneType4: 0,
    creatorKonAddId: 0,
    konAddId: 0,
    email: '',
    image: '/fake-user-image.png',
    role: '',
    description: '',
    country: '',
    contacts: [],
    dealContacts: [],
    position: '',
    contactTypeDesc: '',
    contactStatus: '',
    contactCode: '',
    firstName: '',
    lastName: '',
    startDate: '',
    endDate: '',
    contactId: 0,
    kontactId: 0,
    kontactCode: '',
    creatorCode: '',
    ipiList: [],
    street: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    addressLine4: '',
    projectContactId: 0,
    AKAsList: [],
};
